export const ComponentEnum = [
    {
        id: "HeroSearch",
        name: "Hero Search",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "background", label: "Background Image", required: true, type: "image" },
            { name: "center", label: "Center Image", required: false, type: "image" },
            { name: "link", label: "Link", required: false },
        ]
    },
    {
        id: "Newsletter",
        name: "Newsletter",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "header", label: "Header text", required: true },
            { name: "description", label: "Description", required: true }
        ]
    },
    {
        id: "FaqContentPage",
        name: "Faq Content Page",
        fields: [
            { name: "id", label: "Id", required: true }
        ]
    },
    {
        id: "TradeFiltersContent",
        name: "Trade Filters Content",
        fields: [
            { name: "id", label: "Id", required: true }
        ]
    },
    {
        id: "Instagram",
        name: "Instagram Carousel",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "link", label: "Link", required: true }             
            ]}           
        ]
    },
    {
        id: "SignUpButton",
        name: "Sign Up Button",
        fields: [
            { name: "id", label: "Id", required: true }
        ]
    },
    {
        id: "DesignerResourceToggler",
        name: "Designer Resource Toggler",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "label", label: "Label", required: true }
        ]
    },
    {
        id: "SectionWithBackgroundImage",
        name: "Section With Background Image",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "image", label: "Image", required: true, type: "image" },
            { name: "description", label: "Description", required: true },
            { name: "link", label: "Link", required: false },
            { name: "button_label", label: "Button Label", required: false }
        ]
    },
    {
        id: "SectionWithImageAside",
        name: "Section With Image Aside",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "image", label: "Image", required: true, type: "image" },
            { name: "description", label: "Description", required: true },
            { name: "link", label: "Link", required: false },
            { name: "button_label", label: "Button Label", required: false }
        ]
    },
    {
        id: "FeaturedFarbricsSection",
        name: "Featured Farbrics Section",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: true },
            { name: "products", label: "Products", required: true, type: "array", additional: [
                { name: "product", label: "Product", required: true, type: "product"}        
            ]}
        ]
    },
    {
        id: "NewCollectionSection",
        name: "New Collection Section",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "image", label: "Image", required: true, type: "image"},
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "title", label: "Title", required: true },
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "link", label: "Link", required: true, type: "product_slug"}             
            ]}           
        ]
    },
    {
        id: "StoreList",
        name: "Store List",
        fields: [
            { name: "id", label: "Id", required: true }
        ]
    },
    {
        id: "CardsSection",
        name: "Cards Section",
        fields: [
            { name: "id", label: "Id", required: true },
            { name: "title", label: "Title", required: false},
            { name: "items", label: "Items", required: true, type: "array", additional: [
                { name: "title", label: "Title", required: true },
                { name: "image", label: "Image", required: true, type: "image"},
                { name: "middle_image", label: "Middle Image", required: false, type: "image"},
                { name: "description", label: "Description", required: true },
                { name: "link", label: "Link", required: true }, 
                { name: "link_label", label: "Link Label", required: true }
            ]}           
        ]
    },
]